//   给弹窗里面塞内容开始
const productInfo = window.productMeta || {
    image: '/path/to/thumb.jpg',
    title: 'Product Title',
    price: '$168.17',
    compareAt: '$198.17'
  };
  
  let swiperZoomInstance = null;
  let swiperThumbInstance = null;
  // ✅ 放在所有函数或事件监听器**外面**
  window.videoStatusMap = new Map();

  function buildZoomSlidesHTML(mediaData) {
    return mediaData.map(item => {
      if (item.type === 'image') {
        return `
          <div class="swiper-slide" data-media-id="${item.id}">
            <img src="${item.image}" alt="${item.alt}" style="width:100%;height:auto;" />
          </div>`;
      } else if (item.type === 'video' || (item.alt && item.alt.includes('.mp4'))) {
        if(jQuery(window).width()<768){
            return `
            <div class="swiper-slide" data-media-id="${item.id}">
              <video class="custom-video" muted playsinline preload="auto" poster="${item.poster || ''}">
                <source src="${item.alt}" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div class="pos video-controls"> 
                <img src="https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552" width="40" height="40" class="playBtn" />
                <div class="video-controls-cen">
                  <!-- 声音控制按钮 -->
                  <button class="muteButton">
                    <span class="iconfont icon-Volume-Up"></span>
                  </button>
                  <!-- 进度条 -->
                  <div class="progressBarContainer">
                    <div class="progressBar" style="width: 0;"></div>
                  </div>
                  <!-- 剩余时间 -->
                  <div class="end_in_time">
                    -<span class="end_min">00</span>:<span class="end_second">00</span>
                  </div>
                </div>
              </div>
            </div>
          `;
        }else{
            return `
            <div class="swiper-slide" data-media-id="${item.id}">
              <video class="custom-video" muted playsinline controls preload="auto" poster="${item.poster || ''}">
                <source src="${item.alt}" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          `;
        }

      } else {
        return '';
      }
    }).join('');
  }

  function buildThumbnailSlidesHTML(mediaData) {
    return mediaData.map(item => {
      const thumb = item.thumb || item.image || item.poster || '';
      return `
        <div class="swiper-slide">
          <img src="${thumb}" alt="${item.alt}" />
        </div>`;
    }).join('');
  }
//   给弹窗里面塞内容结束

// 弹窗大图里面的内容以及逻辑
// 工具函数：判断是否正在播放
function isVideoPlaying(video) {
  return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState >= 2);
}

// 弹窗大图逻辑
let isFirstSlideChange = true;
window.initMediaZoomModal = function (triggerElements) {
  triggerElements.forEach(el => {
    el.addEventListener('click', function () {
      console.log('点击弹出大图弹窗');
      const isFromQuickShop = !!el.closest('.quick-shop-cen');
      const wrapper = document.querySelector('#MediaZoomModal .swiper-zoom-modal .swiper-wrapper');
      const small_wrapper = document.querySelector('#MediaZoomModal .swiper-thumbnails .swiper-wrapper');

      if (isFromQuickShop) {
        $('.zoom-product-addtocart').attr('data-from', 'quickshop');
        $('#MediaZoomModal').css('height', '100vh');
        if (jQuery(window).width() <= 768) {
          $('.MediaZoomModal-cen').css('top','50%');
        }
        console.log('获取body滚动的高度',$('body').attr('data-overflow-top'));
        sessionStorage.setItem('modalScrollY', `-${$('body').attr('data-overflow-top')}px`);
        document.querySelector('.zoom-product-thumb').src = $('.quick-shop-cen .new_ProductItem_pic_all img').first().attr('src');
        document.querySelector('.zoom-product-title').textContent = $('.quick-shop-cen .ProductItem__Title .ptit').text();
        $('.zoom-product-prices').html($('.quick-shop-cen .ProductItem__PriceList').html());
        wrapper.innerHTML = '';
        small_wrapper.innerHTML = '';
        const images = el.closest('.quick-shop-cen').querySelectorAll('.ProductItem__Image');
        images.forEach(img => {
          const clone = img.cloneNode(true);
          const thumbImg = img.cloneNode(true);
          wrapper.appendChild(clone);
          small_wrapper.appendChild(thumbImg);
        });
        $('#MediaZoomModal .swiper-slide').css('height', 'auto');
        window.swiperZoomInstance?.update();
        window.swiperThumbInstance?.update();
      } else {
        console.log('详情页大图弹窗');
        $('.zoom-product-addtocart').attr('data-from', 'detail');
        document.querySelector('.zoom-product-thumb').src = productInfo.image;
        document.querySelector('.zoom-product-title').textContent = productInfo.title;
        $('.zoom-product-prices').html($('.ProductMeta__PriceList').html());
        // if (typeof window.stopAutoPlay === 'function') window.stopAutoPlay();
        wrapper.innerHTML = buildZoomSlidesHTML(window.productMediaData);
        small_wrapper.innerHTML = buildThumbnailSlidesHTML(window.productMediaData);
        if (jQuery(window).width() <= 768) {
          document.querySelector('.ProductForm__BuyButtons').style.display = 'block';
          document.querySelector('.ProductForm__BuyButtons .buy_btn_save').style.display = 'block';
          // $('.ProductForm__BuyButtons').style.display = 'block';
          if (jQuery(window).width() <= 768){
            console.log('m弹窗弹出,禁止body滚动');
                // 记录当前滚动位置

            scrollY = window.scrollY;
            // 锁定 body，避免滚动时浏览器地址栏收起
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            var shopBottomHeight = $('.ProductForm__BuyButtons').outerHeight(true) || 0;
            var fullHeight = window.innerHeight; // 窗口总高度
            $('#MediaZoomModal').css('height', (fullHeight - shopBottomHeight) + 'px');
          }
        }
      }

      // 弹出后初始化视频控件
      setTimeout(() => {
        if (jQuery(window).width() <= 768){
          const activeSlide = document.querySelector('.swiper-slide-active');
          if (activeSlide && activeSlide.querySelector('video')) {
            window.setupVideoControls();
          }
        }
      }, 200);

      document.getElementById('MediaZoomModal').style.display = 'block';
 
      // 销毁旧 swiper 实例
      window.swiperZoomInstance?.destroy(true, true);
      window.swiperThumbInstance?.destroy(true, true);

      window.swiperThumbInstance = new Swiper('.swiper-thumbnails', {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
      });

      window.swiperZoomInstance = new Swiper('.swiper-zoom-modal', {
        initialSlide: parseInt(el.dataset.index || 0),
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        thumbs: {
          swiper: window.swiperThumbInstance
        },
        on: {
          slideChange: function() {
            console.log('视频或图片切换');
            
            // 1. 首先保存离开视频的状态（在暂停之前）
            const prevSlide = this.slides[this.previousIndex];
            if (prevSlide) {
              const prevVideo = prevSlide.querySelector('video');
              if (prevVideo) {
                // 保存状态 - 必须在暂停前获取播放状态
                const videoSrc = prevVideo.currentSrc || prevVideo.src;
                window.videoStatusMap.set(videoSrc, {
                  wasPlaying: !prevVideo.paused, // 获取真实播放状态
                  wasMuted: prevVideo.muted,
                  currentTime: prevVideo.currentTime
                });
              }
            }
            
            // 2. 暂停所有视频并解绑移动端事件
            document.querySelectorAll('#MediaZoomModal video').forEach(v => {
              // 暂停视频
              v.pause();
              
              // 解绑移动端事件
              if (v._boundHandleProgress) {
                v.removeEventListener('timeupdate', v._boundHandleProgress);
                delete v._boundHandleProgress;
              }
            });
          
            // 3. 更新离开视频的按钮状态
            if (prevSlide) {
              const prevVideo = prevSlide.querySelector('video');
              if (prevVideo && window.innerWidth <= 768) {
                const playBtn = prevSlide.querySelector('.playBtn');
                if (playBtn) {
                  playBtn.src = 'https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552';
                }
              }
            }
            
            // 4. 处理新激活的视频
            const currentSlide = this.slides[this.activeIndex];
            if (!currentSlide) return;
            
            const currentVideo = currentSlide.querySelector('video');
            if (!currentVideo) return;
            
            const videoSrc = currentVideo.currentSrc || currentVideo.src;
            const status = window.videoStatusMap.get(videoSrc) || {};
            
            // 恢复基本状态
            if (status.currentTime) {
              currentVideo.currentTime = status.currentTime;
            }
            currentVideo.muted = status.wasMuted ?? true;
            
            const isMobile = window.innerWidth <= 768;
            
            // 移动端处理
            if (isMobile) {
              // 隐藏浏览器默认控件
              currentVideo.controls = false;
              
              // 获取播放按钮
              const playBtn = currentSlide.querySelector('.playBtn');
              if (playBtn) {
                // 更新播放按钮状态
                playBtn.src = status.wasPlaying
                  ? "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552"
                  : "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552";
                
                // 绑定自定义控件
                requestAnimationFrame(() => {
                  window.setupVideoControls?.();
                });
                
                // 恢复播放状态
                if (status.wasPlaying) {
                  // 添加延迟确保视频元素已准备好
                  setTimeout(() => {
                    currentVideo.play().catch(err => {
                      console.warn('移动端自动播放失败:', err);
                      playBtn.src = "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552";
                    });
                  }, 100);
                }
              }
            } 
            // PC端处理
            else {
              console.log('pc视频切换');
              
              // 显示浏览器默认控件
              currentVideo.controls = true;
              
              // 确保自定义控件隐藏（如果有）
              const customControls = currentSlide.querySelector('.custom-video-controls');
              if (customControls) {
                customControls.style.display = 'none';
              }
              
              // 创建播放尝试函数
              const tryPlayVideo = () => {
                console.log('pc视频切换02');
                if (status.wasPlaying) {
                  console.log('返回需要播放的视频');
                  
                  // 尝试播放视频
                  const playPromise = currentVideo.play();
                  
                  if (playPromise !== undefined) {
                    playPromise
                      .then(() => {
                        console.log('PC视频自动播放成功');
                      })
                      .catch(err => {
                        console.warn('PC端自动播放失败:', err);
                        // 显示控件让用户手动播放
                        currentVideo.controls = true;
                      });
                  }
                } else {
                  // 如果之前是暂停状态，确保显示暂停状态
                  currentVideo.pause();
                }
              };
          
              // 创建播放尝试处理函数
              const handlePlayAttempt = () => {
                tryPlayVideo();
              };
          
              // 创建错误处理函数
              const handleVideoError = () => {
                console.error('视频加载错误');
                tryPlayVideo();
              };
          
              // 尝试播放
              console.log(`视频准备状态: ${currentVideo.readyState}`);
              
              // 简化播放逻辑 - 直接尝试播放
              if (status.wasPlaying) {
                // 添加延迟确保视频元素准备好
                setTimeout(() => {
                  tryPlayVideo();
                }, 100);
              } else {
                currentVideo.pause();
              }
              
              // 添加事件监听确保播放
              currentVideo.addEventListener('loadedmetadata', handlePlayAttempt, { once: true });
              currentVideo.addEventListener('canplay', handlePlayAttempt, { once: true });
              currentVideo.addEventListener('error', handleVideoError, { once: true });
              
              // 确保进度显示正确
              if (status.currentTime) {
                currentVideo.currentTime = status.currentTime;
              }
            }
          }
       
        }
      });
    });
  });

  // 注册关闭按钮
  const closeBtn = document.querySelector('.zoom-modal-close');
  if (closeBtn && !closeBtn.dataset.bound) {
    closeBtn.dataset.bound = 'true';
    closeBtn.addEventListener('click',function () {
      console.log('点击关闭按钮，关闭弹窗');
      closeZoomModal();
    })
  }

  // 点击空白关闭
  const modal = document.getElementById('MediaZoomModal');
  if (modal && !modal.dataset.bound) {
    modal.dataset.bound = 'true';
    modal.addEventListener('click', function (e) {
      // e.target === this 表示点击的是真正的背景，而不是内部元素
      if(jQuery(window).width()>768){
        const zoom = this.querySelector('.MediaZoomModal-cen .swiper-zoom-modal');
        const prevBtn = this.querySelector('.swiper-button-prev');
        const nextBtn = this.querySelector('.swiper-button-next');
        const thumbs = this.querySelector('.swiper-thumbnails');
        const productInfo = this.querySelector('.media-zoom-product-info');
        const closeBtn = this.querySelector('.zoom-modal-close');
           // 如果点击不在以上元素内，就关闭
        if (
          !zoom.contains(e.target) &&
          !prevBtn.contains(e.target) &&
          !nextBtn.contains(e.target) &&
          !thumbs.contains(e.target) &&
          !productInfo.contains(e.target) &&
          e.target !== closeBtn
        ) {
          console.log('点击遮罩区域关闭弹窗');
          closeZoomModal();
        }
      }else{
        if (e.target === this) {
          console.log('m点击空白,关闭弹窗');
          closeZoomModal();
        }
      }

    });
  }
  
};
// 封装关闭逻辑
function closeZoomModal() {
  const scrollY = parseInt(sessionStorage.getItem('modalScrollY')) || 0;
  console.log('获取打开大图弹窗的高度',scrollY);
  // 还原 body 样式
  if($('body').attr('data-overflow-top')){
    document.body.style.position = 'fixed';
    document.body.style.top = `-${$('body').attr('data-overflow-top')}px`;
    document.body.style.width = '';
    document.body.style.overflow = '';
  }else{
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
  }


  // 恢复滚动位置
  window.scrollTo(0, scrollY);

  // 关闭弹窗
  document.getElementById('MediaZoomModal').style.display = 'none';

  // 销毁 swiper
  window.swiperZoomInstance?.destroy(true, true);
  window.swiperThumbInstance?.destroy(true, true);
}

document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.Product__SlideItem--image, .Product__SlideItem--video');
    window.initMediaZoomModal(elements);
});

function video_list(){
  console.log('进入视频 v1 --- ' + Date.now());
    $('.MediaZoomModal-cen .swiper-container .swiper-slide .custom-video').each(function(){
      $(this).off("click").on("click",function(){
        console.log('点击视频，出现视频弹窗');
        sessionStorage.setItem('popupVisible', 'true'); // 设置状态
        if(jQuery(window).width()>768){
          $('.video_poupop .video_poupop_cen video').attr('controls', '');
        }
        $('.video_poupop .video_poupop_cen video').attr('data-video-src',$(this).attr('data-video-src'));
        $('.video_poupop .video_poupop_cen video').attr('poster',$(this).find('picture').find('.cover_pic').attr('src'));
        $('.video_poupop .video_poupop_cen source').attr('src',$(this).attr('data-video-src'));
            $('.video_product_cen a').on('click', function (event) {
              localStorage.setItem('video_scrol_top', newscrollTop);
              sessionStorage.removeItem('popupVisible'); // 清除状态
              var video = $('.video_poupop_cen_con video')[0]; // 获取video DOM对象
              const $video = $('.video_poupop_cen_con video');
              $video.prop('muted', true); // 关闭时静音
              $('.video_poupop .muteButton .iconfont').addClass('.icon-Volume-Up').removeClass('icon-Volume');
              $('.video_poupop .muteButton').show();
              $('.video_poupop .playBtn').attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_c319d62f-3d8f-4178-bd53-dd2320361abf.png?v=1715329552');
              video.pause(); //暂停控制
              setTimeout(function(){  
                $('.video_poupop .window-cover').css('display','none');
                $('.video_poupop .video_poupop_cen').css('display','none');
              },2000)
            })
        const $loading = $('#video_loading');
        $loading.show(); // 显示加载标记
        const $video = $('.video_poupop .video_poupop_cen video');
        const video = $('.video_poupop .video_poupop_cen video')[0];
        $video[0].currentTime = 0;                
        $('.video_poupop .video_poupop_cen_con .progressBar').css('width',0);
        $video.prop('muted', true); // 确保视频静音
        $video[0].load(); // 触发视频加载
          $video[0].addEventListener('loadeddata', function() {
              $loading.hide(); // 隐藏加载标记
              $video[0].play();
              $('.video_poupop .playBtn').attr('src','https://cdn.shopify.com/s/files/1/1720/3725/files/Frame-1.png?v=1715329552');
               // 进度条
            var progressBar = $('.video_poupop .video_poupop_cen_con .progressBar');
            var handleProgress = function(){
              var percentage = (100 / video.duration) * video.currentTime;
              if((video.duration-video.currentTime)/60>1){
                var min_num=Math.floor((video.duration-video.currentTime)/60);
                if(min_num<10){
                  $('.end_min').text('0'+ min_num);
                }else{
                  $('.end_min').text(min_num);
                }
                if(Math.floor(video.duration-min_num*60-video.currentTime)<10){
                    $('.end_second').text('0'+ Math.floor(video.duration-min_num*60-video.currentTime)); 
                }else{
                    $('.end_second').text(Math.floor(video.duration-min_num*60-video.currentTime));
                }
              }else{
                 $('.end_min').text('00');
                if(Math.floor(video.duration-video.currentTime)<10){
                    $('.end_second').text('0'+ Math.floor(video.duration-video.currentTime)); 
                }else{
                    $('.end_second').text(Math.floor(video.duration-video.currentTime));
                }
                 
              }
              progressBar.css('width', percentage + '%');
            };
            $video[0].addEventListener('timeupdate', handleProgress, false);
          });
        
        $('.video_poupop .video_product .video_title_cen').text($(this).attr('data-video_name'));
  
        // 文案是否折叠
        const $text = $('.video_title_cen');
        const $button = $('.video_toggle_button'); 
        // 检查文本是否超出 2 行
        if ($text[0].scrollHeight > $text.outerHeight()) {
            $button.show(); // 显示展开按钮
        }
        // 点击按钮展开/折叠
        $button.on('click', function() {
            $('.video_title').toggleClass('expand');
            $(this).text($('.video_title').hasClass('expand') ? '╱╲' : '╲╱');
        });
         var newscrollTop = $(window).scrollTop();
         if(jQuery(window).width()>769){
          $('body').attr('data-overflow-top',newscrollTop);
          $('body').css({
            'overflow': 'hidden',
            'position': 'fixed',
            'top': '-' + newscrollTop + 'px',
            'left': '0',
            'right': '0',
            'bottom': '0'
          });
         }
  
        $('.video_poupop .window-cover').css('display','block');
        $('.video_poupop .video_poupop_cen').css('display','block');
      })
    })
}